module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl2-50.7c9a9368.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-C-lvl2-50.png
// module id = 3390
// module chunks = 11